import { useSelector, useDispatch } from "react-redux";
import styles from "./index.css";
import logo from "./logo.png";
import classNames from "classnames";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";
import LoyaltyOptInModalButtons from "./LoyaltyOptInModalButtons";
import shouldShowModal from "./shouldShowModal";
import redirect from "./redirect";
import BottomLinks from "./BottomLinks";
import NoisyText from "./NoisyText";
import ProductImages from "./ProductImages";
import useOverflowControl from "./useOverflowControl";
import {
  getLoyaltyIsOptedIn,
  getLoyaltyIsEnabled,
  getEnableComplianceVariant,
  getStoreCode
} from "../../state/modules/config/selectors";
import {
  analyticsLoyaltyOptInClick,
  analyticsLoyaltyOptInReject
} from "../../state/modules/analytics/actions";

import { getCategoryDetails } from "../../state/modules/category";
import { loyaltyOptIn } from "../../state/modules/config/actions";
import { getFeatures } from "../../featuresStore";

const LoyaltyOptInModal = ({ formatTranslation }) => {
  const dispatch = useDispatch();
  const loyaltyIsOptedIn = useSelector(getLoyaltyIsOptedIn);
  const categoryDetails = useSelector(getCategoryDetails);
  const loyaltyIsEnabled = useSelector(getLoyaltyIsEnabled);
  const enableComplianceVariant = useSelector(getEnableComplianceVariant);
  const storeCode = useSelector(getStoreCode);

  const loyaltyBenefitType = categoryDetails.loyaltyBenefit?.type;

  const { decisions } = getFeatures() || {};
  const loyaltyNewInExperimentEnabled = Boolean(
    decisions?.["loyalty-new-in-today-lock-product"]
  );
  const showModal = shouldShowModal({
    loyaltyBenefitType,
    loyaltyIsEnabled,
    loyaltyIsOptedIn,
    loyaltyNewInExperimentEnabled
  });

  useOverflowControl(showModal);

  if (!showModal) {
    return null;
  }

  return (
    <div className={styles.loyaltyOptInModal}>
      <div className={styles.container}>
        <button
          className={styles.closeButton}
          onClick={() => {
            dispatch(analyticsLoyaltyOptInReject());
            redirect();
          }}
          aria-label={formatTranslation("accessibility_label_close")}
        />
        <img
          alt={formatTranslation("quick_join_overlay_a11y_logo")}
          src={logo}
          className={styles.logo}
        />
        <div>
          {!enableComplianceVariant && <ProductImages />}
          <NoisyText enableComplianceVariant={enableComplianceVariant} />
        </div>
        {!enableComplianceVariant && (
          <div className={classNames("leavesden1", styles.copy)}>
            {formatTranslation("quick_join_overlay_body_web")}
          </div>
        )}
        <LoyaltyOptInModalButtons
          enableComplianceVariant={enableComplianceVariant}
          storeCode={storeCode}
          loyaltyOptIn={() => {
            dispatch(analyticsLoyaltyOptInClick());

            return dispatch(loyaltyOptIn());
          }}
          loyaltyReject={() => {
            dispatch(analyticsLoyaltyOptInReject());
            redirect();
          }}
        />
        <BottomLinks enableComplianceVariant={enableComplianceVariant} />
      </div>
    </div>
  );
};

LoyaltyOptInModal.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(LoyaltyOptInModal);
